<template>
	<div class="ProductManage">
		<common-body aside="9">
			<div slot="commonMain" class="pm-page">
				<!-- 入口页：三个独立入口 -->
				<div v-if="!manageEntered" class="pm-gate">
					<div class="pm-gate__inner pm-gate__inner--entries">
						<h1 class="pm-gate__title">产品管理</h1>
						<p class="pm-gate__desc">选择要进入的功能模块</p>
						<div class="pm-gate__entries">
							<button type="button" class="pm-gate__entry" @click="enterSection('goods')">
								<span class="pm-gate__entry-title">商品管理</span>
								<span class="pm-gate__entry-desc">按分类维护商品信息、规格与上下架</span>
							</button>
							<button type="button" class="pm-gate__entry" @click="enterSection('extra')">
								<span class="pm-gate__entry-title">附加项设置</span>
								<span class="pm-gate__entry-desc">维护运费、打包等附加收费项</span>
							</button>
							<button type="button" class="pm-gate__entry" @click="enterSection('factoryStock')">
								<span class="pm-gate__entry-title">工厂库存</span>
								<span class="pm-gate__entry-desc">物料进货、配方、未发货原料需求与流水</span>
							</button>
							<button type="button" class="pm-gate__entry" @click="enterSection('parameter')">
								<span class="pm-gate__entry-title">参数管理</span>
								<span class="pm-gate__entry-desc">维护工艺参数维度与可选项，供商品报价勾选</span>
							</button>
						</div>
					</div>
				</div>

				<template v-else>
				<div class="pm-section-bar">
					<button type="button" class="pm-back-btn" @click="backToGate">
						<i class="el-icon-arrow-left"></i> 返回入口
					</button>
					<span class="pm-section-bar__label">{{ sectionTitle }}</span>
					<el-tabs
						v-if="showRootTabs && rootCategories.length"
						v-model="activeRootTab"
						class="pm-section-tabs"
						@tab-click="onRootTabChange">
						<el-tab-pane
							v-for="root in rootCategories"
							:key="root.id"
							:label="root.name"
							:name="String(root.id)" />
					</el-tabs>
					<div v-if="manageSection === 'goods'" class="pm-section-bar__ops">
						<el-button v-if="canEdit && activeRootId" size="mini" @click="openBoardDialog('edit')">编辑产品分类</el-button>
						<el-button v-if="canAdd" size="mini" type="primary" plain @click="openBoardDialog('add')">添加产品分类</el-button>
					</div>
				</div>
				<template v-if="manageSection === 'factoryStock'">
					<FactoryStockManage :root-pid="activeRootId" :root-name="activeRootName" />
				</template>
				<template v-else-if="manageSection === 'goods'">
				<header class="pm-header">
					<div class="pm-header__text">
						<h1 class="pm-title">商品管理</h1>
						<p class="pm-subtitle">按产品分类维护商品；工具栏「分类管理」维护当前产品分类下的商品分类</p>
					</div>
					<div v-if="listTotal" class="pm-stat">共 <strong>{{ listTotal }}</strong> 条商品</div>
				</header>

				<section class="pm-card">
					<div v-if="!rootCategories.length" class="pm-empty">
						暂无产品分类
						<el-button v-if="canAdd" type="text" @click="openBoardDialog('add')">添加产品分类</el-button>
					</div>

					<div class="pm-toolbar">
						<div class="pm-toolbar__filters">
							<el-input
								v-model="search"
								class="pm-search"
								clearable
								prefix-icon="el-icon-search"
								placeholder="搜索名称 / 型号"
								@keyup.enter.native="searchList"
								@clear="searchList" />
							<el-select
								v-model="subCategoryIndex"
								class="pm-select"
								placeholder="商品分类"
								@change="onSubCategoryChange">
								<el-option v-for="(item, index) in subCategories" :key="item.id || index" :label="item.name" :value="index" />
							</el-select>
						</div>
						<div class="pm-toolbar__actions">
							<el-button v-if="canAdd || canEdit" icon="el-icon-s-operation" @click="openCategoryDialog">分类管理</el-button>
							<el-button v-if="canAdd" type="primary" icon="el-icon-plus" class="pm-btn-primary" @click="addProduct">添加商品</el-button>
							<el-button
								v-if="canDel"
								type="danger"
								plain
								icon="el-icon-delete"
								:disabled="!selectedIds.length"
								@click="batchDelete">批量删除</el-button>
						</div>
					</div>

					<el-table
						v-loading="loading"
						:data="list"
						stripe
						class="pm-table"
						style="width: 100%"
						cell-class-name="pm-cell"
						header-cell-class-name="pm-header-cell"
						@selection-change="onSelectionChange">
						<el-table-column v-if="canDel" type="selection" width="48" />
						<el-table-column align="center" width="60" label="ID" prop="id" />
					<el-table-column align="left" min-width="140" prop="name" label="名称" show-overflow-tooltip />
					<el-table-column align="left" min-width="120" prop="model" label="型号" show-overflow-tooltip />
					<el-table-column align="left" min-width="100" label="分类">
						<template slot-scope="scope">
							<div>{{ scope.row.category && scope.row.category.name ? scope.row.category.name : '—' }}</div>
						</template>
					</el-table-column>
					<el-table-column align="center" width="72" label="图片">
						<template slot-scope="scope">
							<div class="list-thumb-cell">
								<img v-if="scope.row.image" class="list-thumb" :src="scope.row.image" alt="" />
								<span v-else class="list-thumb list-thumb--empty">—</span>
							</div>
						</template>
					</el-table-column>
					<el-table-column align="center" width="72" prop="unit" label="单位" />
					<el-table-column align="left" min-width="108" prop="valuation_text" label="计价方式" show-overflow-tooltip />
					<el-table-column align="center" width="80" label="上下架">
						<template slot-scope="scope">
							<el-switch
								:value="normalizeStatus(scope.row.status)"
								:disabled="!canEdit || statusUpdatingId === scope.row.id"
								@change="toggleStatus(scope.row, $event)" />
						</template>
					</el-table-column>
					<el-table-column align="center" width="72" prop="sort" label="排序" />
					<el-table-column align="center" width="168" label="创建时间">
						<template slot-scope="scope"><span class="pm-time">{{ formatTime(scope.row.createtime) }}</span></template>
					</el-table-column>
					<el-table-column align="center" width="96" label="操作" fixed="right">
						<template slot-scope="scope">
							<div v-if="canEdit || canDel" class="row-actions">
								<el-tooltip v-if="canEdit" content="编辑" placement="top">
									<el-button type="text" icon="el-icon-edit" class="row-action-btn" @click="editProduct(scope.row.id)" />
								</el-tooltip>
								<el-popconfirm v-if="canDel" @onConfirm="delProduct(scope.row.id)"
									confirmButtonType="danger" confirmButtonText="删除" title="确定删除该商品吗？">
									<el-button slot="reference" type="text" icon="el-icon-delete" class="row-action-btn row-action-btn--danger" />
								</el-popconfirm>
							</div>
							<span v-else>—</span>
						</template>
					</el-table-column>
				</el-table>

					<el-pagination
						class="pm-pagination"
						:hide-on-single-page="pageSingle"
						@current-change="changePage"
						@size-change="changePageSize"
						:current-page="page"
						:page-size="limit"
						:page-sizes="[10, 20, 50]"
						background
						layout="total, sizes, prev, pager, next"
						:total="listTotal" />
				</section>
				</template>
				<section v-else-if="manageSection === 'extra'" class="pm-card pm-card--extra">
					<extra-item-manage :can-add="canAdd" :can-edit="canEdit" :can-del="canDel" />
				</section>
				<section v-else-if="manageSection === 'parameter'" class="pm-card">
					<parameter-manage :can-add="canAdd" :can-edit="canEdit" :can-del="canDel" />
				</section>
				</template>
			</div>
		</common-body>
		<product-edit-drawer
			v-if="manageEntered && manageSection === 'goods'"
			ref="editDrawer"
			:categories="categories"
			:valuation-list="valuationList"
			:parameter-options="parameterOptions"
			:specs-price-columns="specsPriceColumns"
			:default-root-id="activeRootId"
			@saved="getList" />
		<el-dialog
			:title="categoryDialogTitle"
			:visible.sync="categoryDialogVisible"
			width="640px"
			append-to-body
			custom-class="pm-category-dialog">
			<category-manage
				v-if="categoryDialogVisible"
				:root-pid="activeRootId"
				:root-name="activeRootName"
				:can-add="canAdd"
				:can-edit="canEdit"
				:can-del="canDel"
				@changed="onCategoryChanged" />
		</el-dialog>
		<el-dialog
			:title="boardForm.id ? '编辑产品分类' : '添加产品分类'"
			:visible.sync="boardDialogVisible"
			width="520px"
			append-to-body
			custom-class="pm-category-dialog"
			@close="resetBoardForm">
			<el-form ref="boardForm" :model="boardForm" :rules="boardRules" label-width="72px">
				<el-form-item label="名称" prop="name">
					<el-input v-model="boardForm.name" placeholder="产品分类名称，对应顶部页签" />
				</el-form-item>
				<el-form-item label="排序">
					<el-input-number v-model="boardForm.weigh" :min="0" style="width: 100%" />
				</el-form-item>
				<el-form-item label="图片" prop="image">
					<el-input v-model="boardForm.image" placeholder="图片路径或 URL" />
				</el-form-item>
				<el-form-item label="描述" prop="content">
					<el-input v-model="boardForm.content" type="textarea" :rows="3" placeholder="产品分类描述" />
				</el-form-item>
			</el-form>
			<div slot="footer">
				<el-button @click="boardDialogVisible = false">取消</el-button>
				<el-button type="primary" :loading="boardSaving" @click="saveBoardForm">保存</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import ProductEditDrawer from '@/components/ProductEditDrawer/index.vue';
import ExtraItemManage from '@/components/ExtraItemManage/index.vue';
import FactoryStockManage from '@/components/FactoryStockManage/index.vue';
import ParameterManage from '@/components/ParameterManage/index.vue';
import CategoryManage from '@/components/CategoryManage/index.vue';
import { DEFAULT_SPECS_PRICE_COLUMNS, flattenDescendantCategories } from '@/utils/goods-edit';

export default {
	name: 'ProductManage',
	components: { ProductEditDrawer, ExtraItemManage, FactoryStockManage, ParameterManage, CategoryManage },
	data() {
		return {
			manageEntered: false,
			manageSection: 'goods',
			ruleList: JSON.parse(localStorage.getItem('ruleList') || '{}'),
			loading: false,
			search: '',
			activeRootTab: '',
			rootCategories: [],
			subCategories: [{ id: '', name: '全部商品分类' }],
			subCategoryIndex: 0,
			page: 1,
			pageSingle: false,
			limit: 10,
			listTotal: 0,
			list: [],
			selectedIds: [],
			statusUpdatingId: 0,
			categories: [],
			valuationList: {},
			parameterOptions: [],
			specsPriceColumns: DEFAULT_SPECS_PRICE_COLUMNS,
			categoryDialogVisible: false,
			boardDialogVisible: false,
			boardSaving: false,
			pendingBoardSelect: '',
			boardForm: { id: 0, name: '', weigh: 0, image: '', content: '' },
			boardRules: {
				name: [{ required: true, message: '请输入产品分类名称', trigger: 'blur' }],
				image: [{ required: true, message: '请添加图片', trigger: 'blur' }],
				content: [{ required: true, message: '请添加描述', trigger: 'blur' }],
			},
		};
	},
	computed: {
		activeRootId() {
			return Number(this.activeRootTab) || 0;
		},
		activeRootName() {
			const root = this.rootCategories.find((r) => String(r.id) === String(this.activeRootTab));
			return root ? root.name : '';
		},
		sectionTitle() {
			if (this.manageSection === 'extra') return '附加项设置';
			if (this.manageSection === 'factoryStock') return '工厂库存';
			if (this.manageSection === 'parameter') return '参数管理';
			return '商品管理';
		},
		showRootTabs() {
			return this.manageSection === 'goods' || this.manageSection === 'factoryStock';
		},
		categoryDialogTitle() {
			return this.activeRootName ? ('商品分类 · ' + this.activeRootName) : '商品分类';
		},
		canAdd() {
			return !!this.ruleList.goods_manage_add;
		},
		canEdit() {
			return !!this.ruleList.goods_manage_edit;
		},
		canDel() {
			return !!this.ruleList.goods_manage_del;
		},
	},
	beforeRouteLeave(to, from, next) {
		this.manageEntered = false;
		this.manageSection = 'goods';
		from.meta.keepAlive = false;
		next();
	},
	created() {
		const section = this.$route.query.section;
		if (section) this.enterSection(String(section), true);
	},
	watch: {
		'$route.query.section'(val) {
			if (val) {
				if (this.manageSection !== String(val) || !this.manageEntered) {
					this.enterSection(String(val), true);
				}
				return;
			}
			this.manageEntered = false;
			this.manageSection = 'goods';
		},
	},
	methods: {
		enterSection(section, fromRoute) {
			const next = section || 'goods';
			this.manageSection = next;
			this.manageEntered = true;
			if (!fromRoute && this.$route.query.section !== next) {
				this.$router.replace({ path: '/productManage', query: { section: next } });
			}
			if (next === 'goods' || next === 'factoryStock') {
				this.$nextTick(() => {
					this.initPage(next);
				});
			}
		},
		backToGate() {
			this.manageEntered = false;
			this.manageSection = 'goods';
			if (this.$route.query.section) {
				this.$router.replace({ path: '/productManage' });
			}
		},
		formatTime(ts) {
			const n = Number(ts);
			if (!n) return '—';
			const d = new Date(n * 1000);
			const pad = (v) => String(v).padStart(2, '0');
			return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()) + ' ' + pad(d.getHours()) + ':' + pad(d.getMinutes());
		},
		normalizeStatus(status) {
			return status === true || status === 1 || status === '1';
		},
		toggleStatus(row, nextStatus) {
			const that = this;
			if (!that.canEdit || !row || !row.id) return;
			const prevStatus = that.normalizeStatus(row.status);
			if (prevStatus === nextStatus) return;
			that.statusUpdatingId = row.id;
			row.status = nextStatus;
			that.$fetch('addons/hlm/api.Goods/manageSetStatus', {
				id: row.id,
				status: nextStatus ? 1 : 0,
			}).then(function(res) {
				if (res.code === 1) {
					that.$message.success(res.msg || '状态已更新');
				} else {
					row.status = prevStatus;
				}
			}).catch(function() {
				row.status = prevStatus;
			}).finally(function() {
				that.statusUpdatingId = 0;
			});
		},
		initPage(section) {
			const that = this;
			const target = section || that.manageSection;
			const needMeta = target === 'goods';
			const tasks = [that.$fetch('addons/hlm/api.Goods/getCategory', { pid: 0 })];
			if (needMeta) tasks.push(that.$fetch('addons/hlm/api.Goods/manageMeta'));
			Promise.all(tasks).then(function(results) {
				const catRes = results[0];
				if (catRes.code === 1) {
					that.rootCategories = catRes.data || [];
					if (that.rootCategories.length) {
						const pending = String(that.pendingBoardSelect || '').trim();
						const pendingHit = pending && that.rootCategories.find((r) => r.name === pending);
						if (pendingHit) {
							that.activeRootTab = String(pendingHit.id);
							that.pendingBoardSelect = '';
						} else {
							const stillValid = that.rootCategories.some((r) => String(r.id) === String(that.activeRootTab));
							if (!stillValid) that.activeRootTab = String(that.rootCategories[0].id);
						}
					}
				}
				if (needMeta && results[1] && results[1].code === 1) {
					const metaRes = results[1];
					that.categories = metaRes.data.categories || [];
					that.valuationList = metaRes.data.valuationList || {};
					that.parameterOptions = metaRes.data.parameterOptions || [];
					that.specsPriceColumns = metaRes.data.specsPriceColumns || DEFAULT_SPECS_PRICE_COLUMNS;
				}
				if (target === 'goods') that.loadSubCategories(true);
			});
		},
		loadSubCategories(reloadList, rootId) {
			const that = this;
			const pid = rootId || that.activeRootId;
			if (!pid) {
				that.subCategories = [{ id: '', name: '全部商品分类' }];
				that.subCategoryIndex = 0;
				if (reloadList) that.getList();
				return;
			}
			const apply = function(list) {
				that.subCategories = [{ id: '', name: '全部商品分类' }].concat(list || []);
				that.subCategoryIndex = 0;
				if (reloadList) {
					that.page = 1;
					that.getList(pid);
				}
			};
			if (that.categories && that.categories.length) {
				apply(flattenDescendantCategories(that.categories, pid));
				return;
			}
			that.$fetch('addons/hlm/api.Goods/getCategory', { pid }).then(function(res) {
				apply(res.code === 1 ? (res.data || []) : []);
			});
		},
		onRootTabChange(tab) {
			const rootId = Number(tab.name);
			if (!rootId) return;
			if (this.manageSection === 'goods') {
				this.search = '';
				this.selectedIds = [];
				this.page = 1;
				this.loadSubCategories(true, rootId);
			}
			// factoryStock：子组件 watch rootPid 自行刷新
		},
		onSubCategoryChange() {
			this.page = 1;
			this.getList();
		},
		openCategoryDialog() {
			if (!this.activeRootId) {
				this.$message.warning('请先添加产品分类');
				return;
			}
			this.categoryDialogVisible = true;
		},
		onCategoryChanged() {
			this.initPage('goods');
		},
		openBoardDialog(mode) {
			if (mode === 'edit') {
				const root = this.rootCategories.find((r) => String(r.id) === String(this.activeRootTab));
				if (!root) {
					this.$message.warning('请先选择产品分类');
					return;
				}
				const that = this;
				that.$fetch('addons/hlm/api.FrontAdmin/manageDetail', { resource: 'category', id: root.id }).then(function(res) {
					if (res.code !== 1) return;
					const row = res.data || {};
					that.boardForm = {
						id: Number(row.id || 0),
						name: String(row.name || ''),
						weigh: Number(row.weigh || 0),
						image: String(row.image || ''),
						content: String(row.content || ''),
					};
					that.boardDialogVisible = true;
				});
				return;
			}
			this.boardForm = { id: 0, name: '', weigh: 0, image: '', content: '' };
			this.boardDialogVisible = true;
		},
		resetBoardForm() {
			this.boardForm = { id: 0, name: '', weigh: 0, image: '', content: '' };
		},
		saveBoardForm() {
			const that = this;
			that.$refs.boardForm.validate(function(valid) {
				if (!valid) return;
				that.boardSaving = true;
				that.$post('addons/hlm/api.FrontAdmin/manageSave', {
					resource: 'category',
					id: that.boardForm.id,
					name: that.boardForm.name,
					weigh: that.boardForm.weigh,
					image: that.boardForm.image,
					content: that.boardForm.content,
					pid: 0,
				}).then(function(res) {
					if (res.code === 1) {
						that.$message.success(res.msg || '保存成功');
						if (!that.boardForm.id) that.pendingBoardSelect = that.boardForm.name;
						that.boardDialogVisible = false;
						that.initPage('goods');
					}
				}).finally(function() {
					that.boardSaving = false;
				});
			});
		},
		getList(rootId) {
			const that = this;
			const pid = rootId || that.activeRootId;
			if (!pid) return;
			that.loading = true;
			const params = {
				page: that.page,
				limit: that.limit,
				search: that.search,
				pid,
			};
			const sub = that.subCategories[that.subCategoryIndex];
			if (sub && sub.id) {
				delete params.pid;
				params.category_id = sub.id;
			}
			that.$fetch('addons/hlm/api.Goods/manageList', params).then(function(res) {
				if (res.code === 1) {
					that.list = res.data.list || [];
					that.listTotal = res.data.total || 0;
					that.pageSingle = that.listTotal <= that.limit;
				}
			}).finally(function() {
				that.loading = false;
			});
		},
		onSelectionChange(rows) {
			this.selectedIds = rows.map((r) => r.id).filter(Boolean);
		},
		changePage(e) {
			this.page = e;
			this.getList();
		},
		changePageSize(size) {
			this.limit = size;
			this.page = 1;
			this.getList();
		},
		searchList() {
			this.page = 1;
			this.getList();
		},
		addProduct() {
			this.$refs.editDrawer.openCreate(this.activeRootId);
		},
		editProduct(id) {
			this.$refs.editDrawer.openEdit(id);
		},
		delProduct(id) {
			this.deleteByIds(String(id));
		},
		batchDelete() {
			if (!this.selectedIds.length) return;
			const that = this;
			that.$confirm('确定删除选中的 ' + that.selectedIds.length + ' 条商品？', '提示', {
				type: 'warning',
			}).then(function() {
				that.deleteByIds(that.selectedIds.join(','));
			}).catch(function() {});
		},
		deleteByIds(ids) {
			const that = this;
			that.$fetch('addons/hlm/api.Goods/manageDel', { ids }).then(function(res) {
				if (res.code === 1) {
					that.$message.success('删除成功');
					that.getList();
				}
			});
		},
	},
};
</script>

<style scoped>
/* ── Design tokens (inherit global theme) ── */
.ProductManage {
	--pm-primary: var(--app-primary);
	--pm-primary-hover: var(--app-primary-hover);
	--pm-primary-light: var(--app-primary-light);
	--pm-text: var(--app-text);
	--pm-text-secondary: var(--app-text-secondary);
	--pm-text-muted: var(--app-text-muted);
	--pm-border: var(--app-border);
	--pm-bg: var(--app-bg);
	--pm-card: var(--app-card);
	--pm-radius: var(--app-radius);
	font-family: var(--app-font);
	color: var(--pm-text);
}

.pm-card--extra {
	padding-bottom: 8px;
}
.pm-section-bar {
	display: flex;
	align-items: center;
	gap: 12px;
	margin-bottom: 14px;
	min-width: 0;
}
.pm-back-btn {
	display: inline-flex;
	align-items: center;
	gap: 2px;
	flex-shrink: 0;
	height: 32px;
	padding: 0 10px;
	border: 1px solid var(--pm-border);
	border-radius: 8px;
	background: #fff;
	color: var(--pm-text-secondary);
	font-size: 13px;
	font-weight: 500;
	cursor: pointer;
	transition: color 0.15s, border-color 0.15s, background 0.15s;
}
.pm-back-btn:hover {
	color: var(--pm-primary);
	border-color: var(--pm-primary);
	background: var(--pm-primary-light, #ecfdf5);
}
.pm-section-bar__label {
	flex-shrink: 0;
	font-size: 14px;
	font-weight: 600;
	color: var(--pm-text);
}
.pm-section-tabs {
	flex: 1;
	min-width: 0;
	margin-left: 4px;
}
.pm-section-bar__ops {
	display: flex;
	align-items: center;
	gap: 6px;
	flex-shrink: 0;
}
.pm-section-tabs >>> .el-tabs__header {
	margin: 0;
}
.pm-section-tabs >>> .el-tabs__nav-wrap::after {
	display: none;
}
.pm-section-tabs >>> .el-tabs__item {
	height: 36px;
	line-height: 36px;
	padding: 0 14px;
	font-size: 13px;
	font-weight: 500;
	color: var(--pm-text-secondary);
}
.pm-section-tabs >>> .el-tabs__item.is-active {
	color: var(--pm-primary);
	font-weight: 600;
}
.pm-section-tabs >>> .el-tabs__item:hover {
	color: var(--pm-primary);
}
.pm-section-tabs >>> .el-tabs__active-bar {
	height: 2px;
	background-color: var(--pm-primary);
}

/* ── Page header ── */
.pm-page {
	min-height: 100%;
}

/* ── Entry gate ── */
.pm-gate {
	min-height: calc(100vh - 160px);
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 40px 20px;
	box-sizing: border-box;
}
.pm-gate__inner {
	width: 100%;
	max-width: 420px;
	text-align: center;
}
.pm-gate__inner--entries {
	max-width: 920px;
}
.pm-gate__title {
	margin: 0;
	font-size: 24px;
	font-weight: 600;
	line-height: 1.3;
	color: var(--pm-text);
	letter-spacing: -0.02em;
}
.pm-gate__desc {
	margin: 10px 0 0;
	font-size: 14px;
	line-height: 1.55;
	color: var(--pm-text-secondary);
}
.pm-gate__entries {
	display: grid;
	grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
	gap: 14px;
	margin-top: 28px;
	text-align: left;
}
.pm-gate__entry {
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	gap: 8px;
	min-height: 128px;
	padding: 18px 16px;
	border: 1px solid var(--pm-border);
	border-radius: 12px;
	background: #fff;
	cursor: pointer;
	transition: border-color 0.15s, box-shadow 0.15s, transform 0.15s;
}
.pm-gate__entry:hover {
	border-color: var(--pm-primary, #45b299);
	box-shadow: 0 8px 24px rgba(15, 23, 42, 0.06);
	transform: translateY(-1px);
}
.pm-gate__entry-title {
	font-size: 16px;
	font-weight: 700;
	color: var(--pm-text);
}
.pm-gate__entry-desc {
	font-size: 13px;
	line-height: 1.45;
	color: var(--pm-text-secondary);
}
@media (max-width: 720px) {
	.pm-gate__entries {
		grid-template-columns: 1fr;
	}
}

.pm-header {
	display: flex;
	align-items: flex-end;
	justify-content: space-between;
	gap: 16px;
	margin-bottom: 16px;
}
.pm-title {
	margin: 0;
	font-size: 22px;
	font-weight: 600;
	line-height: 1.3;
	color: var(--pm-text);
	letter-spacing: -0.02em;
}
.pm-subtitle {
	margin: 6px 0 0;
	font-size: 13px;
	line-height: 1.5;
	color: var(--pm-text-secondary);
	font-weight: 400;
}
.pm-stat {
	flex-shrink: 0;
	padding: 6px 14px;
	font-size: 13px;
	color: var(--pm-text-secondary);
	background: var(--pm-card);
	border: 1px solid var(--pm-border);
	border-radius: 20px;
}
.pm-stat strong {
	color: var(--pm-primary);
	font-weight: 600;
}

/* ── Card container ── */
.pm-card {
	background: var(--pm-card);
	border: 1px solid var(--pm-border);
	border-radius: var(--pm-radius);
	box-shadow: 0 1px 3px rgba(15, 23, 42, 0.04);
	overflow: hidden;
}

/* ── Category tabs ── */
.pm-tabs >>> .el-tabs__header {
	margin: 0;
	padding: 0 20px;
	background: #f9fafb;
	border-bottom: 1px solid var(--pm-border);
}
.pm-tabs >>> .el-tabs__nav-wrap::after {
	display: none;
}
.pm-tabs >>> .el-tabs__item {
	height: 44px;
	line-height: 44px;
	padding: 0 18px;
	font-size: 14px;
	font-weight: 500;
	color: var(--pm-text-secondary);
	transition: color 0.2s;
}
.pm-tabs >>> .el-tabs__item.is-active {
	color: var(--pm-primary);
	font-weight: 600;
}
.pm-tabs >>> .el-tabs__item:hover {
	color: var(--pm-primary);
}
.pm-tabs >>> .el-tabs__active-bar {
	height: 2px;
	background-color: var(--pm-primary);
}
.pm-empty {
	padding: 32px 20px;
	text-align: center;
	font-size: 14px;
	color: var(--pm-text-muted);
}

/* ── Toolbar ── */
.pm-toolbar {
	display: flex;
	align-items: center;
	justify-content: space-between;
	flex-wrap: wrap;
	gap: 12px;
	padding: 16px 20px;
	border-bottom: 1px solid var(--pm-border);
}
.pm-toolbar__filters {
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	gap: 10px;
}
.pm-toolbar__actions {
	display: flex;
	align-items: center;
	gap: 8px;
	flex-shrink: 0;
}
.pm-search {
	width: 260px;
}
.pm-search >>> .el-input__inner {
	height: 36px;
	line-height: 36px;
	font-size: 13px;
	border-radius: 6px;
	border-color: var(--pm-border);
	color: var(--pm-text);
}
.pm-search >>> .el-input__inner:focus {
	border-color: var(--pm-primary);
}
.pm-search >>> .el-input__prefix {
	color: var(--pm-text-muted);
}
.pm-select {
	width: 168px;
}
.pm-select >>> .el-input__inner {
	height: 36px;
	line-height: 36px;
	font-size: 13px;
	border-radius: 6px;
	border-color: var(--pm-border);
}
.pm-btn-primary {
	background-color: var(--pm-primary);
	border-color: var(--pm-primary);
	font-size: 13px;
	font-weight: 500;
	padding: 9px 16px;
	border-radius: 6px;
}
.pm-btn-primary:hover,
.pm-btn-primary:focus {
	background-color: var(--pm-primary-hover);
	border-color: var(--pm-primary-hover);
}
.pm-toolbar__actions >>> .el-button {
	font-size: 13px;
	border-radius: 6px;
	padding: 9px 14px;
}

/* ── Table ── */
.pm-table {
	font-size: 13px;
}
.pm-table >>> .pm-header-cell {
	background: #f9fafb !important;
	font-size: 13px;
	font-weight: 600;
	color: var(--pm-text-secondary);
	padding: 10px 0;
	border-bottom: 1px solid var(--pm-border);
}
.pm-table >>> .pm-header-cell .cell {
	font-weight: 600;
}
.pm-table >>> .pm-cell {
	font-size: 13px;
	color: var(--pm-text);
	padding: 0 !important;
}
.pm-table >>> .el-table__body tr {
	height: 56px;
}
.pm-table >>> .el-table__body td .cell {
	line-height: 1.4;
}
.pm-table >>> .el-table--striped .el-table__body tr.el-table__row--striped td {
	background: #fafbfc;
}
.pm-table >>> .el-table__body tr:hover > td {
	background: var(--pm-primary-light) !important;
}
.pm-table >>> .el-table__fixed-right-patch {
	background: #f9fafb;
}
.pm-time {
	font-size: 12px;
	color: var(--pm-text-secondary);
	font-variant-numeric: tabular-nums;
}
.list-thumb-cell {
	display: flex;
	align-items: center;
	justify-content: center;
	height: 40px;
}
.list-thumb {
	width: 40px;
	height: 40px;
	object-fit: cover;
	border-radius: 6px;
	flex-shrink: 0;
	border: 1px solid var(--pm-border);
}
.list-thumb--empty {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	background: #f3f4f6;
	color: var(--pm-text-muted);
	font-size: 12px;
	line-height: 1;
	border: 1px dashed var(--pm-border);
}
.row-actions {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	gap: 2px;
	height: 40px;
}
.row-action-btn {
	padding: 6px;
	font-size: 16px;
	color: var(--pm-primary);
}
.row-action-btn:hover {
	color: var(--pm-primary-hover);
	background: var(--pm-primary-light);
	border-radius: 4px;
}
.row-action-btn--danger {
	color: #ef4444;
}
.row-action-btn--danger:hover {
	color: #dc2626;
	background: #fef2f2;
}
.pm-table >>> .el-switch.is-checked .el-switch__core {
	border-color: var(--pm-primary);
	background-color: var(--pm-primary);
}

/* ── Pagination ── */
.pm-pagination {
	display: flex;
	justify-content: flex-end;
	padding: 16px 20px;
	border-top: 1px solid var(--pm-border);
}
.pm-pagination >>> .el-pagination__total,
.pm-pagination >>> .el-pagination__sizes {
	font-size: 13px;
	color: var(--pm-text-secondary);
}
.pm-pagination >>> .el-pager li {
	font-size: 13px;
	min-width: 32px;
	height: 32px;
	line-height: 32px;
	border-radius: 6px;
	font-weight: 500;
}
.pm-pagination >>> .el-pager li.active {
	background-color: var(--pm-primary) !important;
}
.pm-pagination >>> .btn-prev,
.pm-pagination >>> .btn-next {
	min-width: 32px;
	height: 32px;
	line-height: 32px;
	border-radius: 6px;
	font-size: 13px;
}
</style>
<style>
.pm-category-dialog {
	max-width: calc(100vw - 32px);
}
.pm-category-dialog .el-dialog {
	margin-top: 8vh !important;
	overflow: hidden;
}
.pm-category-dialog .el-dialog__body {
	overflow-x: hidden;
	padding: 12px 20px 20px;
}
.pm-category-dialog .el-table,
.pm-category-dialog .el-table__body-wrapper,
.pm-category-dialog .el-table__header-wrapper {
	width: 100% !important;
	overflow-x: hidden !important;
}
.cm-form-dialog {
	max-width: calc(100vw - 32px);
}
.cm-form-dialog .el-dialog__body {
	overflow-x: hidden;
}
</style>
